'use strict';

angular.module('user')
    .component('recoverPasswordForm', {
        templateUrl: 'js/modules/user/components/recover-password-form/template.html',
        controller: 'RecoverPasswordFormController',
        controllerAs: 'RecoverController',
        bindings: {
            onSubmit: '&',
        },
    });
